import React from "react";

import { setFilter } from "QuotePage/Actions";
import { getSortedPlanSuiteBasePlans } from "QuotePage/Selectors";
import { connect } from "react-redux";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { TitleSmall } from "Cobalt/Header";
import BodyText from "Common/BodyText";
import Button from "Common/Button";
import { Card } from "Common/Card/";
import { isSampleQuote } from "Common/EnterAges/Selectors";
import { Div } from "Common/HTML";

import makeBem from "Utils/makeBem";

const bem = makeBem("MultiplePlansCard");

class MultiplePlansCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: props.firstRecommendation };
  }

  toggle = () => {
    AnalyticsTracking.trackEvent(this.state.isOpen ? "plan_card_collapse" : "plan_card_expand", {
      location: "multiple_plans_card",
      custom_recommendation: !!this.props.customRecommendation,
    });

    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    const { customRecommendation } = this.props;
    return (
      <Card
        mb={this.state.isOpen || !customRecommendation ? 2 : 0}
        style={{ paddingTop: "24px", paddingBottom: "24px" }}
        className={this.state.isOpen ? bem(null, "open") : bem(null, "closed")}
        mb={4}
      >
        <Div className="flex-space-between" style={{ alignItems: "center" }}>
          <Div style={{ paddingRight: "64px" }}>
            <TitleSmall mb={0} mt={0}>
              Offer a Plan Package
            </TitleSmall>
            <BodyText>
              One plan might not fit all your employees. By offering a package of several plans, your employees can choose the right one for their needs.
            </BodyText>
            <BodyText mt={3}>Each package contains plans from one carrier with varrying levels of coverage.</BodyText>
          </Div>
          <Div style={{ textAlign: "right" }}>
            <Button
              color="blue"
              fullWidth
              size="medium"
              onClick={() => {
                AnalyticsTracking.trackEvent("cta_clicked", {
                  location: "multiple_plans_card",
                  action: "view_packages",
                  custom_recommendation: !!this.props.customRecommendation,
                });

                AnalyticsTracking.trackEvent("clicked_multiple_plans", {
                  location: "multiple_plans_card",
                  custom_recommendation: !!this.props.customRecommendation,
                });

                this.props.onClick();
              }}
            >
              View Plan Packages
            </Button>
          </Div>
        </Div>
      </Card>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const basePlans = getSortedPlanSuiteBasePlans(state);
  return {
    plan: basePlans[0],
    isSampleQuote: isSampleQuote(state),
    firstRecommendation: ownProps.firstRecommendation || false,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onClick: () => {
    dispatch(setFilter("recommendation_mode", "multiple_plans"));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MultiplePlansCard);
